import {
  ContainerOutlined,
  EditOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UnlockOutlined,
} from '@ant-design/icons';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { BackTopProps, Button, Form, message, Space, Tag, Tooltip } from 'antd';
import confirm from 'antd/lib/modal/confirm';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PageContext } from '../../../lib/context';
import mutations from '../../../utils/gql/mutations';
import queries from '../../../utils/gql/queries';
import MeterView from './meter-view';
import { Switch } from 'antd';

interface MeterInput {
  serial_number: string;
  id: number;
  date_added: Date;
  is_taken: boolean;
}

interface Meter {
  id: number;
  serial_number: string;
  date_added: Date;
  is_taken: boolean;
}

interface Sort {
  serial_number: string | null | boolean;
  reading_value: string | null | boolean;
  created_at: string | null | boolean;
  name: string | null | boolean;
  status: string | null | boolean;
}

interface Array {

}

const MeterController = () => {
  const [sort, setSort] = useState<any>(null);
  const [sortOrder, setSortOrder] = useState<Sort>({
    serial_number: false,
    reading_value: false,
    created_at: false,
    name: false,
    status: false,
  });
  const handleSort = (pagination: any, filters: any, sorter: any) => {
    const sorterOrder: any = {
      ascend: 'asc',
      descend: 'desc'
    }
    console.log(sorter.columnKey)
    if (sorter.columnKey === 'subscriber') {
      setSort({
        name: sorterOrder[sorter.order]
      });
      setSortOrder({ ...sortOrder, name: sorter.order });
    } else {
      setSort({
        [sorter.columnKey]: sorterOrder[sorter.order]
      });
      setSortOrder({ ...sortOrder, [sorter.columnKey]: sorter.order });
    }
  };

  const columns = [
    {
      title: 'Serial Number',
      dataIndex: 'serial_number',
      key: 'serial_number',
      sorter: true,
      sortOrder: sortOrder.serial_number,
    },
    {
      title: 'Latest Reading Date',
      key: 'updated_at',
      render: (record: any) => {
        if (record.meter_readings.length > 0) {
          return moment(record?.meter_readings?.[0].updated_at).format('LLL');
        } else {
          return null;
        }
      },
      sorter: false,
    },

    {
      title: 'Latest Reading Value',
      key: 'reading_value',
      dataIndex: 'reading_value',
      sorter: true,
      sortOrder: sortOrder.reading_value
    },
    {
      title: 'Battery',
      key: 'battery',
      render: (record: any) => {
        if (record.meter_readings.length > 0) {
          return record?.meter_readings?.[0]?.battery;
        } else {
          return null;
        }
      },
      sorter: false,
    },
    {
      title: 'Date Added',
      key: 'date_added',
      render: (record: any) => moment(record.created_at).format('LLL'),
      sorter: true,
      sortOrder: sortOrder.created_at
    },
    {
      title: 'Subscriber',
      key: 'subscriber',
      render: (record: any) => {
        return (
          <Link to={`/customers/${record.subscriber_id}`}>{record.name}</Link>
        );
      },
      sorter: true,
      sortOrder: sortOrder.name
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      sorter: true,
      sortOrder: sortOrder.status
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space>
          <Tooltip title="Show Recent Reading">
            <Button type="link" onClick={_showMeterReading.bind(this, record)}>
              <ContainerOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Edit Meter">
            <Button type="link" onClick={_showEditHandler(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Release Meter">
            <Button
              type="link"
              onClick={() => {
                confirm({
                  title:
                    'Once released, it will detach the meter to the subscriber.',
                  onOk() {
                    releaseMeter({
                      variables: {
                        id: record.id,
                      },
                    });
                  },
                });
              }}
            >
              <UnlockOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Add Reading">
            <Button type="link" onClick={() => _addReading(record)}>
              <PlusCircleOutlined />
            </Button>
          </Tooltip>
          <Switch
            defaultChecked={record.is_active}
            onChange={val => _updateValveStatus(val, record)}
            size="small"
          />
        </Space>
      ),
    },
  ];
  const params: any = useParams();
  const [total, setTotal] = useState<number>();
  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalColor, setTotalColor] = useState<number>();
  const [limitColor, setLimitColor] = useState<number>(10);
  const [offsetColor, setOffsetColor] = useState<number>(0);
  const [currentPageColor, setCurrentPageColor] = useState<number>(1);
  const [form] = Form.useForm();
  const [readingForm] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [editId, setEditId] = useState<null | number>(null);
  const [meters, setMeters] = useState<Meter[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const [color, setColor] = useState<string | null>(null);
  const [selectedMeter, setSelectedMeter] = useState<any>();
  const [csv, setCSV] = useState<any[]>([]);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [meterColors, setMeterColors] = useState<any[]>([]);
  const [addReading, setAddReading] = useState<boolean>(false);
  const [current, setCurrent] = useState<any>();
  const { data: get_meter_count } = useQuery(queries.GET_METER_COUNT, {
    fetchPolicy: 'no-cache',
  });
  const [getColor, { data: colors, loading: color_loading }] = useLazyQuery(queries.GET_COLORS, {
    fetchPolicy: 'no-cache',
  });
  const { data: color_count } = useQuery(queries.GET_COLOR_COUNT, {
    fetchPolicy: 'no-cache',
  });
  const [releaseMeter] = useMutation(mutations.RELEASE_METER, {
    onCompleted(res) {
      message.success('Release Successful!');
      _getMeter();
    },
    onError({ graphQLErrors }) {
      message.error('Failed!');
    },
  });
  const [createReading] = useMutation(mutations.CREATE_READING, {
    onCompleted() {
      message.success('Reading added successfully!');
      setAddReading(false);
      _getMeter();
      readingForm.resetFields();
    },
    onError({ graphQLErrors }) {
      message.error(graphQLErrors[0].message);
    },
  });
  const [insertMeter] = useMutation<MeterInput>(mutations.INSERT_UPDATE_METER, {
    onCompleted(res) {
      message.success('Meter created successfully.');
      _getMeter();
      form.resetFields();
      setShow(false);
    },
    onError({ graphQLErrors }) {
      console.log(graphQLErrors);
      message.error('Duplicate serial number.');
    },
  });

  const [updateValveStatus] = useMutation<any>(mutations.UPDATE_VALVE, {
    onCompleted(res) {
      console.log(res);
      if (res.UpdateValveStatus.errcode == 0) {
        message.success('Meter valve status is updated!');
      } else {
        message.error(res.UpdateValveStatus.errmsg);
      }
    },
    onError({ graphQLErrors }) {
      console.log(graphQLErrors);
    },
  });

  const [getMeter, { data, loading: meter_loading }] = useLazyQuery(queries.GET_METER, {
    fetchPolicy: 'no-cache',
  });

  const _submitHandler = () => {
    form.submit();
  };

  const _showMeterReading = (data: any) => {
    setShowForm(false);
    setSelectedMeter(data);
    _showHandler();
  };

  const _showEditHandler = (data: any) => {
    return () => {
      setShowForm(true);
      form.setFieldsValue(data);
      _showHandler();
    };
  };

  const _onFinish = (data: MeterInput) => {
    insertMeter({
      variables: {
        data,
      },
    });
  };

  const _getMeter = () => {
    if (sort?.meter_readings?.[0]) {
      getMeter({
        variables: {
          limit: limit,
          offset: offset,
          order_by1: sort,
        }
      });
    } else {
      getMeter({
        variables: {
          limit: limit,
          offset: offset,
          order_by: sort,
        }
      });
    }
  };

  const _showHandler = (status?: Boolean) => {
    if (status) {
      setShowForm(true);
      form.resetFields();
    }
    setShow(true);
    // form.resetFields()
  };
  const _closeHandler = () => {
    setShow(false);
    setShowForm(false);
  };
  useEffect(() => {
    _getMeter();
  }, [getMeter, sort]);

  useEffect(() => {
    if (data) {
      const items = data.view_meters.map((meters: Meter) => {
        return {
          ...meters,
          status: meters.is_taken ? 'Assigned' : 'Unassigned',
        };
      });
      setMeters(items);
    }
  }, [data]);

  useEffect(() => {
    if (data && params?.id) {
      const paramId = parseInt(params.id);
      const meter = data.view_meters.filter(({ id }: any) => id === paramId);
      _showMeterReading(meter[0]);
    }
  }, [params, data]);

  const getStatus: any = {
    black: 'More than 1 week not reporting',
    green: 'Connected',
    grey: 'More 2 days not reporting',
    orange: 'Not reporting',
    purple: 'Not assigned',
    location: 'No GPS',
  };

  useEffect(() => {
    if (colors) {
      setMeterColors(colors.view_map_csv);
      const header = [
        [
          'Status',
          'Meter ID',
          'Name',
          'Address',
          'Reading Date',
          'Reading Value',
          'GPS',
        ],
      ];
      const items = colors.view_map_csv.map((val: any) => {
        const values = [];
        values.push(getStatus[color ?? 'black']);
        values.push(val.serial_number);
        values.push(val.name);
        values.push(val.complete_address);
        values.push(moment(val.reading_date).format('LLL'));
        values.push(val.meter_reading);
        return values;
      });
      setCSV([...header, ...items]);
    }
  }, [colors]);

  useEffect(() => {
    if (color) {
      if (color === 'black') {
        setTotalColor(color_count?.black?.aggregate?.count);
      } else if (color === 'green') {
        setTotalColor(color_count?.green?.aggregate?.count);
      } else if (color === 'grey') {
        setTotalColor(color_count?.grey?.aggregate?.count);
      } else if (color === 'orange') {
        setTotalColor(color_count?.orange?.aggregate?.count);
      } else if (color === 'purple') {
        setTotalColor(color_count?.purple?.aggregate?.count);
      } else {
        setTotalColor(color_count?.no_location?.aggregate?.count)
      }
      _refreshDrawer();
    }
  }, [color]);

  const _onFinishSearch = (data: any) => {
    getMeter({
      variables: {
        where: {
          _or: [
            {
              serial_number: {
                _ilike: `%${data.serial_number}%`,
              },
            },
            {
              name: {
                _ilike: `%${data.serial_number}%`,
              },
            },
          ],
        },
        limit: limit,
        offset: offset,
        order_by: {
          id: 'desc',
        },
      },
    });
  };

  const _openDrawer = (color: string) => {
    setShowDrawer(true);
    setColor(color);
  };

  const _refreshDrawer = () => {
    if (color !== 'location') {
      getColor({
        variables: {
          where: { color: { _eq: color } },
          limit: limitColor,
          offset: offsetColor,
        },
      });
    } else {
      getColor({
        variables: {
          where: { latitude: { _is_null: true } },
          limit: limitColor,
          offset: offsetColor,
        },
      });
    }
  };

  const _addReading = (data: any) => {
    setAddReading(true);
    setCurrent(data);
  };

  const _confirmReading = (data: any) => {
    createReading({
      variables: {
        meter_id: current.serial_number,
        value: data.reading,
      },
    });
  };

  const _updateValveStatus = (val: any, record: any) => {
    updateValveStatus({
      variables: {
        meter_id: record.serial_number,
        status: val ? '1' : '0',
      },
    });
  };

  useEffect(() => {
    if (get_meter_count) {
      const temp = get_meter_count.view_meters_aggregate;
      setTotal(temp.aggregate.count);
    }
  }, [get_meter_count])

  const handlePaginationChange = (page: any, pageSize: any) => {
    setLimit(pageSize);
    setCurrentPage(page);
    if (page * pageSize > pageSize) {
      setOffset(page * pageSize - pageSize);
    }
    if (page === 1) {
      setCurrentPage(page);
      setOffset(0);
    }
  };

  useEffect(() => {
    if (offset || currentPage) {
      _getMeter();
    }
  }, [offset, currentPage]);

  const handlePaginationChangeColor = (page: any, pageSize: any) => {
    setLimitColor(pageSize);
    setCurrentPageColor(page);
    if (page * pageSize > pageSize) {
      setOffsetColor(page * pageSize - pageSize);
    }
    if (page === 1) {
      setCurrentPageColor(page);
      setOffsetColor(0);
    }
  };

  useEffect(() => {
    if (offsetColor || currentPageColor) {
      _refreshDrawer();
    }
  }, [offsetColor, currentPageColor]);

  const closeDrawer = () => {
    setShowDrawer(false);
    setOffsetColor(0);
    setCurrentPageColor(1);
  };

  const value: object = {
    columns,
    form,
    meters,
    show,
    selectedMeter,
    showForm,
    searchForm,
    color,
    showDrawer,
    meterColors,
    color_count,
    csv,
    current,
    addReading,
    readingForm,
    color_loading,
    meter_loading,
    limit,
    offset,
    total,
    currentPage,
    limitColor,
    offsetColor,
    totalColor,
    currentPageColor,
    handlePaginationChange,
    closeDrawer,
    handlePaginationChangeColor,
    setAddReading,
    setShowDrawer,
    setColor,
    _onFinishSearch,
    _showHandler,
    _closeHandler,
    _submitHandler,
    _onFinish,
    _openDrawer,
    _refreshDrawer,
    _confirmReading,
    handleSort,
  };

  return (
    <PageContext.Provider value={value}>
      <MeterView />
    </PageContext.Provider>
  );
};

export default MeterController;
